import {
    FETCHING_PROMOS_DATA,
    FETCHING_PROMOS_DATA_SUCCESS,
    FETCHING_PROMOS_DATA_FAILURE,
} from '../constants/actionTypes.js';
//import {API_URL} from "../constants/endpoints";
import api from '../api/promos';

export const requestPromos = (data) => {
    return async (dispatch) => {
        dispatch(getData(data));
        try {
            const [response, json] = await api('requestPromos', data);
            json.statusCode = response.status;
            return dispatch(getDataSuccess(json));
        } catch (err) {
            console.log(err);
            return getDataFailure();
        }
    };
};


//API Requests
const getData = (data) => {
    return {
        type: FETCHING_PROMOS_DATA,
        payload: data,
    };
};
const getDataSuccess = (data) => {
    return {
        type: FETCHING_PROMOS_DATA_SUCCESS,
        data,
    };
};
const getDataFailure = () => {
    return {
        type: FETCHING_PROMOS_DATA_FAILURE,
    };
};

